import { render, staticRenderFns } from "./UserHistoryTab.vue?vue&type=template&id=41263988&scoped=true"
import script from "./UserHistoryTab.vue?vue&type=script&lang=js"
export * from "./UserHistoryTab.vue?vue&type=script&lang=js"
import style0 from "./UserHistoryTab.vue?vue&type=style&index=0&id=41263988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41263988",
  null
  
)

export default component.exports